import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";

import "../../../css/DesignSystem/Sidebar/Sidebar.css";
import { auth } from "../../../backend/firebaseConfig";

import { ReactComponent as Logo } from "../../../assets/icons/whiltelogo.svg";
import { ReactComponent as IconExpand } from "../../../assets/icons/icon-Expand.svg";
import { ReactComponent as IconCollapse } from "../../../assets/icons/icon-Collapse.svg";
import { ReactComponent as IconExit } from "../../../assets/icons/Icon-Exit.svg";

import LogoutButton from "../Buttons/LogoutButton";
import { useUserEmail } from "../../../context/UserEmailContext";
import { useUserRole } from "../../../context/UserRoleContext";
import { useAdminMails } from "../../../context/AdminEmailsContext";
// import { useUserEmail } from "../../context/UserEmailContext";
// import { useUserRole } from "../../context/UserRoleContext";
// import { useAdminMails } from "../../context/AdminEmailsContext";
import {ReactComponent as MyChecksIcon} from "../../../assets/icons/MyChecks.svg";
import {ReactComponent as NewCheckIcon} from "../../../assets/icons/NewCheck.svg";
import {ReactComponent as GuideIcon} from "../../../assets/icons/Guide.svg";
import { ReactComponent as StatementIcon } from "../../../assets/icons/statements.svg";

const Sidebar = ({ shouldNavigate, isSetExpanded = false }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isExpanded, setIsExpanded] = useState(isSetExpanded);

  const { userEmail, setUserEmail } = useUserEmail();
  const { userRole, setUserRole } = useUserRole();
  const { setAdminMails } = useAdminMails();

  const navigationItems = [
    {
      label: "My Checks",
      route: "/my-checks",
      icn: MyChecksIcon,
      responsiceIcon: MyChecksIcon,
    },
    {
      label: "New Check",
      route: "/new-check",
      icn: NewCheckIcon,
      responsiceIcon: NewCheckIcon,
    },
    {
      label: "Guide",
      route: "/guide",
      icn: GuideIcon,
      responsiceIcon: GuideIcon,
    },
    ...(userRole === "superadmin"
      ? [
          {
            label: "Statement",
            route: "/statement",
            icn: StatementIcon,
            responsiceIcon: StatementIcon,
          },
        ]
      : []),
  ];

  const handleItemClick = (item) => {
    if (!shouldNavigate || shouldNavigate(item.route)) {
      navigate(item.route);
    }
  };

  const isActiveRoute = (route) => {
    if (location.pathname === route) return true;

    // Keep "My Checks" highlighted while viewing a check details page.
    if (route === "/my-checks" && location.pathname === "/check²/result") {
      return true;
    }

    return false;
  };

  const handleLogout = async () => {
    try {
      const keyUser = (userEmail || "").toLowerCase().trim();

      if (keyUser) {
        sessionStorage.removeItem(`aml_announcement_seen_${keyUser}`);
      }

      await signOut(auth);

      setUserEmail(null);
      setUserRole(null);
      setAdminMails([]);

      localStorage.clear();
      sessionStorage.clear();

      navigate("/", { replace: true });
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  const renderNavItems = (iconClassName) =>
    navigationItems.map((item) => (
      <div
        className={`sidebar-Tab ${isActiveRoute(item.route) ? "active" : ""}`}
        key={item.route}
        onClick={() => handleItemClick(item)}
      >
        <div className={iconClassName}>
          <item.icn />
        </div>

        <div className="sidebar-responsive-icon">
          <item.responsiceIcon />
        </div>

        <div className="nav-item Title">{item.label}</div>
      </div>
    ));

  return (
    <>
      <div className={`sidebar ${isExpanded ? "expanded" : ""}`}>
        <div className={`sidebar-content ${isExpanded ? "expanded" : ""}`}>
          <div className="sidebar-header-row">
            <div className="sidebar-expanded">
              <IconExpand onClick={() => setIsExpanded(!isExpanded)} />
            </div>
            <div className="expandIcon">
              <IconCollapse onClick={() => setIsExpanded(!isExpanded)} />
            </div>
            <div className="sidebar-logo">
              <Logo onClick={() => navigate("/my-checks")} />
            </div>
          </div>

          {renderNavItems("sidebar-defalut-icon")}
        </div>

        <IconExit className="exit-icon" onClick={handleLogout} />

        <div className="sidebar-footer">
          <div className="Label">{auth.currentUser?.displayName || ""}</div>
          <LogoutButton title="Logout" onClick={handleLogout} />
        </div>
      </div>

      <div className={`sidebar-toggle ${isExpanded ? "open" : "closed"}`}>
        <div className="sidebar-toggle-column">
          <div>
            <IconCollapse onClick={() => setIsExpanded(false)} />

            <div className="sidebar-toggle-logo">
              <Logo onClick={() => navigate("/my-checks")} />
            </div>
          </div>

          {navigationItems.map((item) => (
            <div
              className={`sidebar-Tab ${isActiveRoute(item.route) ? "active" : ""}`}
              key={item.route}
              onClick={() => handleItemClick(item)}
            >
              <div className="sidebar-toggle-icon">
                <item.icn />
              </div>

              <div className="Title">{item.label}</div>
            </div>
          ))}
        </div>

        <div className="sidebar-toggle-footer">
          <div className="Label">{auth.currentUser?.displayName || ""}</div>
          <LogoutButton title="Logout" onClick={handleLogout} />
        </div>
      </div>
    </>
  );
};

export default Sidebar;
